import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { GoogleLogo, ArrowRight } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2">
        <div className="hidden lg:flex flex-col justify-between p-12 bg-ink-900 text-white sf-grid-bg-dark relative overflow-hidden">
          <Link to="/" className="flex items-center self-start" data-testid="login-panel-logo" aria-label="SafeForm home">
            <img src="/brand/safeform-lockup-dark.svg" alt="SafeForm" className="h-8 w-auto" />
          </Link>
          <div className="relative">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50 mb-4">For safety officers, ergonomists, and operators</div>
            <h1 className="font-display font-black text-4xl xl:text-5xl tracking-tighter leading-[1.05]">
              Stop repetitive<br />
              <span className="text-safety">strain injuries</span><br />
              before they start.
            </h1>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              Sign in to upload a clip, run an ergonomic analysis, and turn what your eyes can't catch into a written playbook for the floor.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center p-8 lg:p-16">
          <div className="w-full max-w-md">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-500 mb-3">Sign in</div>
            <h2 className="font-display font-black text-4xl tracking-tighter text-ink-900">Welcome back.</h2>
            <p className="mt-3 text-ink-700">Use Google to sign in. No password to remember, no link to expire.</p>

            <div className="mt-10 border border-ink-100 p-6">
              <Button
                data-testid="login-google-btn"
                onClick={startLogin}
                size="lg"
                className="w-full rounded-none bg-ink-900 hover:bg-safety text-white h-12 text-sm font-semibold"
              >
                <GoogleLogo size={18} weight="bold" className="mr-2" />
                Continue with Google
                <ArrowRight size={16} weight="bold" className="ml-auto" />
              </Button>

              <div className="mt-6 border-t border-ink-100 pt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-ink-500 leading-relaxed">
                By continuing you agree to be a workplace that measures its own movement.
                <br />Privacy-first. Videos stay yours.
              </div>
            </div>

            <div className="mt-8 text-sm text-ink-500">
              No account?{" "}
              <button onClick={startLogin} className="text-ink-900 underline underline-offset-4 hover:text-safety" data-testid="login-create-account">
                Create an account
              </button>
            </div>
            <div className="mt-4 text-sm">
              <Link to="/" className="text-ink-500 hover:text-ink-900" data-testid="login-back-home">← Back to home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
